<template>
  <div>    
    <main-content right-sidebar="true">
      <transition-group
        :css="false"
        @enter="enter"
        @afterEnter="afterEnter"
        @leave="leave"
        class="tag-wrapper"
      >
        <template
          v-for="(livingOption, index) in activeLivingOptions"
          :data-index="index"
          tag="div"
        >
          <template v-if="!livingOption.isVisuallyHidden">
            <tag-basic
              v-for="(marker, markerIndex) in livingOption.markers || []"
              v-bind="marker"
              :key="`${livingOption._id}_tag_${markerIndex}`"
              :pos="{
                x: marker.x,
                y: marker.y
              }"
              :show-sold-label="showSoldLabel(livingOption)"
              :label="livingOption.displayName"
              @click.native="$router.push(getLivingOptionNavigationPath(livingOption))"
            />

            <polygon-shape
              v-for="(polygon, polygonIndex) in livingOption.polygons || []"
              :key="polygon._id || `${livingOption._id}_polygon_${polygonIndex}`"
              :polygon="polygon"
              @click.native="$router.push(getLivingOptionNavigationPath(livingOption))"
            />
          </template>
        </template>
      </transition-group>
    </main-content>
  </div>
</template>
<script>
import MainContent from '@/components/MainContent'
import PolygonShape from '@/components/PolygonShape'
import TagBasic from '@/components/TagBasic'
import { bus } from '../main'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  props: ['living-options'],

  components: { MainContent, PolygonShape, TagBasic },

  data () {
    return {
      activeLivingOptions: []
    }
  },

  computed: {
    ...mapGetters({
      language: 'language'
    }),

    categoryId () {
      return this.$route.params.categoryId
    },

    pathway () {
      return this.$route.params.pathway
    },

    styleTemplate () {
      return this.$store.state.styleTemplate
    }
  },

  watch: {
    livingOptions (newLivingOptions, oldLivingOptions) {
      if (!_.isEqual(oldLivingOptions, newLivingOptions)) {
        if (oldLivingOptions.length) {
          this.activeLivingOptions = []
        }

        if (newLivingOptions.length) {
          this.$store.commit('addAnimationToQueue', 'LivingOptionTags')
        }
      }
    }
  },

  mounted () {
    bus.$on('animateLivingOptionTags', () => {
      if (!_.isEqual(this.activeLivingOptions, this.livingOptions)) {
        this.activeLivingOptions = this.livingOptions
      } else {
        bus.$emit('finishedAnimation', 'LivingOptionTags')
      }
    })
  },

  methods: {
    isSoldOut (livingOption) {
      return livingOption.availableProperties === 0
    },
    
    showSoldLabel (livingOption) {
      return this.styleTemplate['general']['show-sold-label'] && this.isSoldOut(livingOption)
    },

    openSubsection (id) {
      const toLivingOption = this.$store.getters['property/livingOptions'].find(livingOption => livingOption._id === id)

      const isSoldOut = toLivingOption.availableProperties === 0
      const canInteract = this.styleTemplate['general']['can-interact-sold-livingoptions']

      if (isSoldOut && !canInteract) {
        return
      }

      // if (toLivingOption.subsections.length === 1) {
        // this.$router.push(`/category/${this.categoryId}/live/${this.pathway}/${id}/subsection/${toLivingOption.subsections[0]._id}?activeSubsectionId=${toLivingOption.subsections[0]._id}`)
      // } else {
        this.$router.push(`/category/${this.categoryId}/live/${this.pathway}/${id}`)
      // }
    },

    getLivingOptionNavigationPath (livingOption) {
      const params = this.$route.params
        if (livingOption.subsections.length === 1) {
          return `/category/${params.categoryId}/live/${params.pathway}/${livingOption._id}/subsection/${livingOption.subsections[0]._id}`
        } else {
          return `/category/${params.categoryId}/live/${params.pathway}/${livingOption._id}`
        }
    },

    polygonUrl (id) {
      const toLivingOption = this.$store.getters['property/livingOptions'].find(livingOption => livingOption._id === id)

      // if (toLivingOption.subsections.length === 1) {
        // return `/category/${this.categoryId}/live/${this.pathway}/${id}/subsection/${toLivingOption.subsections[0]._id}?activeSubsectionId=${toLivingOption.subsections[0]._id}`
      // } else {
        return `/category/${this.categoryId}/live/${this.pathway}/${id}`
      // }
    },

    enter (el, done) {
      const tagType = el.getAttribute('data-type')

      this.animationSpeed = 100

      if (tagType === 'basic') {
        this.animationSpeed = 50
      }

      setTimeout(() => {
        el.classList.add('enter')
        done()
      }, (parseInt(this.delayIndex++) + 1) * this.animationSpeed)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.activeLivingOptions.length) {
        bus.$emit('finishedAnimation', 'LivingOptionTags')
        this.delayIndex = 0
      }
    },

    leave (el) {
      el.classList.add('leave')
      el.classList.remove('enter')
    },
  }
}
</script>
<style lang="scss" scoped>
.tag-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;

  .layout-switched & {
    top: 10rem;
  }
}
</style>
